var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "verification-page"
  }, [_vm._m(0), _c('section', {
    staticClass: "steps-box"
  }, [_vm.loading ? _c('div', {
    staticClass: "loading-indicator"
  }, [_c('p', [_vm._v("Submitting your information...")])]) : _vm._e(), _c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.validateAndSubmit.apply(null, arguments);
      }
    }
  }, [!_vm.submitted ? [_c('div', {
    staticClass: "form-section"
  }, [_c('h3', [_vm._v("1. Hardware Details")]), _c('label', {
    attrs: {
      "for": "smartTrainer"
    }
  }, [_vm._v("Primary Power Source")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.smartTrainer,
      expression: "form.smartTrainer"
    }],
    class: {
      'input-error': _vm.validationErrors.smartTrainer
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "smartTrainer", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Primary Power Source")]), _c('option', [_vm._v("Wahoo KICKR V5")]), _c('option', [_vm._v("Wahoo KICKR V6")]), _c('option', [_vm._v("Wahoo KICKR Move")]), _c('option', [_vm._v("Wahoo KICKR Bike V1")]), _c('option', [_vm._v("Wahoo KICKR Bike V2")]), _c('option', [_vm._v("Wahoo KICKR Shift")]), _c('option', [_vm._v("Wahoo KICKR Core")]), _c('option', [_vm._v("Wahoo KICKR Core 2")]), _c('option', [_vm._v("Tacx Neo")]), _c('option', [_vm._v("Tacx Neo 2T")]), _c('option', [_vm._v("Tacx Neo 3M")]), _c('option', [_vm._v("Tacx Neo Bike")]), _c('option', [_vm._v("Tacx Neo Bike Plus")]), _c('option', [_vm._v("Elite Justo")]), _c('option', [_vm._v("Elite Justo 2")]), _c('option', [_vm._v("Jet Black Victory")]), _c('option', [_vm._v("Elite Justo Avanti")])]), _vm.validationErrors.smartTrainer ? _c('span', {
    staticClass: "error-text"
  }, [_vm._v(_vm._s(_vm.validationErrors.smartTrainer))]) : _vm._e(), _c('label', {
    attrs: {
      "for": "secondaryPowerSource"
    }
  }, [_vm._v("Secondary Power Source")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.secondaryPowerSource,
      expression: "form.secondaryPowerSource"
    }],
    class: {
      'input-error': _vm.validationErrors.secondaryPowerSource
    },
    attrs: {
      "type": "text",
      "placeholder": "Include make, model, serial number of secondary power source (pedals, crank, etc.)"
    },
    domProps: {
      "value": _vm.form.secondaryPowerSource
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "secondaryPowerSource", $event.target.value);
      }
    }
  }), _vm.validationErrors.secondaryPowerSource ? _c('span', {
    staticClass: "error-text"
  }, [_vm._v(" " + _vm._s(_vm.validationErrors.secondaryPowerSource) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "form-section"
  }, [_c('h3', [_vm._v("2. Share your Weight and Height Details")]), _c('p', {
    staticClass: "step-description"
  }, [_vm._v(" Please note that the weight and height must match the weight and height in your videos. ")]), _c('label', {
    attrs: {
      "for": "weight"
    }
  }, [_vm._v("Weight (kg)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.weight,
      expression: "form.weight",
      modifiers: {
        "number": true
      }
    }],
    class: {
      'input-error': _vm.validationErrors.weight
    },
    attrs: {
      "type": "number",
      "step": "0.1",
      "placeholder": "Weight (kg)"
    },
    domProps: {
      "value": _vm.form.weight
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "weight", _vm._n($event.target.value));
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _vm.validationErrors.weight ? _c('span', {
    staticClass: "error-text"
  }, [_vm._v(_vm._s(_vm.validationErrors.weight))]) : _vm._e(), _c('label', {
    attrs: {
      "for": "height"
    }
  }, [_vm._v("Height (cm)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.height,
      expression: "form.height",
      modifiers: {
        "number": true
      }
    }],
    class: {
      'input-error': _vm.validationErrors.height
    },
    attrs: {
      "type": "number",
      "placeholder": "Height (cm)"
    },
    domProps: {
      "value": _vm.form.height
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "height", _vm._n($event.target.value));
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _vm.validationErrors.height ? _c('span', {
    staticClass: "error-text"
  }, [_vm._v(_vm._s(_vm.validationErrors.height))]) : _vm._e()]), _c('div', {
    staticClass: "form-section"
  }, [_c('h3', [_vm._v(" 3. Share video proof for Smart Trainer, Height, Weight, Secondary Power Source and Power Passport Workout ")]), _vm._m(1), _c('label', {
    attrs: {
      "for": "videoLink"
    }
  }, [_vm._v("Video Link")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.videoLink,
      expression: "form.videoLink"
    }],
    class: {
      'input-error': _vm.validationErrors.videoLink
    },
    attrs: {
      "type": "text",
      "placeholder": "https://www.youtube.com/..."
    },
    domProps: {
      "value": _vm.form.videoLink
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "videoLink", $event.target.value);
      }
    }
  }), _vm.validationErrors.videoLink ? _c('span', {
    staticClass: "error-text"
  }, [_vm._v(_vm._s(_vm.validationErrors.videoLink))]) : _vm._e()]), _c('div', {
    staticClass: "form-section"
  }, [_c('h3', [_vm._v("4. Strava link")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.stravaLink,
      expression: "form.stravaLink"
    }],
    class: {
      'input-error': _vm.validationErrors.stravaLink
    },
    attrs: {
      "type": "text",
      "placeholder": "Your public strava link"
    },
    domProps: {
      "value": _vm.form.stravaLink
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "stravaLink", $event.target.value);
      }
    }
  }), _vm.validationErrors.stravaLink ? _c('span', {
    staticClass: "error-text"
  }, [_vm._v(_vm._s(_vm.validationErrors.stravaLink))]) : _vm._e()]), _c('div', {
    staticClass: "form-section"
  }, [_c('h3', [_vm._v("5. Message")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.message,
      expression: "form.message"
    }],
    attrs: {
      "placeholder": "Any message..."
    },
    domProps: {
      "value": _vm.form.message
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "message", $event.target.value);
      }
    }
  })]), _c('p', {
    staticClass: "note"
  }, [_vm._v(" ⚠ Please note that the verification process for all steps is expected to be completed within 72 hours. ")]), _vm.errors.length ? _c('div', {
    staticClass: "error-messages"
  }, [_c('h4', [_vm._v("Please correct the following errors:")]), _c('ul', _vm._l(_vm.errors, function (error, index) {
    return _c('li', {
      key: index,
      staticClass: "error-item"
    }, [_vm._v(" " + _vm._s(error) + " ")]);
  }), 0)]) : _vm._e(), _c('div', {
    staticClass: "form-actions justify-end"
  }, [_c('button', {
    staticClass: "btn-cancel",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" Cancel ")]), _c('button', {
    staticClass: "btn-submit",
    attrs: {
      "type": "submit",
      "disabled": _vm.loading
    }
  }, [_vm._v(" Submit ")])])] : _vm._e()], 2), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.submitted ? [_c('div', {
    staticClass: "success-message"
  }, [_c('h3', [_vm._v("Thank you for your submission!")]), _c('p', [_vm._v(" Your verification request has been received. We will review it within the next 12 hours. ")])])] : _vm._e()], 2)], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("Pre-Verification Form")]), _c('ul', [_c('li', [_vm._v(" It is crucial that you input all the details correctly, so please spend the time to read the "), _c('a', {
    attrs: {
      "href": "https://mywhoosh.com/ruleset",
      "target": "_blank"
    }
  }, [_vm._v("technical guide and ruleset")]), _vm._v(" and be as thorough as possible. ")]), _c('li', [_vm._v(" All videos must now be submitted as an unlisted YouTube link. No direct file submission will be accepted. ")])]), _c('p', [_vm._v(" For any issues with this form, please contact "), _c('a', {
    attrs: {
      "href": "mailto:racecontrol@mywhoosh.com"
    }
  }, [_vm._v("racecontrol@mywhoosh.com")]), _vm._v(". ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "step-description"
  }, [_vm._v(" The accepted protocol for power passport text, weigh-in, height and equipment videos can be found in the "), _c('a', {
    attrs: {
      "href": "https://mywhoosh.com/ruleset",
      "target": "_blank"
    }
  }, [_vm._v("MyWhoosh ruleset")])]);
}]

export { render, staticRenderFns }